import script from "./IssuerDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./IssuerDetail.vue?vue&type=script&setup=true&lang=ts"

import "./IssuerDetail.vue?vue&type=style&index=0&id=2654c2d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2654c2d1"]])

export default __exports__